import React, { useEffect, useState } from 'react';
import './App.css';
import CustomCursor from './components/CustomCursor';
import MatrixBackground from './components/MatrixBackground';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Skills from './components/Skills';
import Projects from './components/Projects';
import Timeline from './components/Timeline';
import Contact from './components/Contact';
import Footer from './components/Footer';
import { easterEggs } from './mock';

function App() {
  const [keyBuffer, setKeyBuffer] = useState('');
  const [easterEggActive, setEasterEggActive] = useState(null);

  useEffect(() => {
    const handleKeyPress = (e) => {
      const newBuffer = (keyBuffer + e.key).slice(-15).toLowerCase();
      setKeyBuffer(newBuffer);

      // Check for easter eggs
      Object.values(easterEggs).forEach(egg => {
        if (newBuffer.includes(egg.trigger)) {
          setEasterEggActive(egg);
          setTimeout(() => setEasterEggActive(null), 3000);
        }
      });
    };

    window.addEventListener('keypress', handleKeyPress);
    return () => window.removeEventListener('keypress', handleKeyPress);
  }, [keyBuffer]);

  return (
    <div className="App" style={{
      background: '#000000',
      minHeight: '100vh',
      position: 'relative',
      overflow: 'hidden'
    }}>
      <CustomCursor />
      <MatrixBackground variant="matrix" />
      
      {/* Easter egg notification */}
      {easterEggActive && (
        <div style={{
          position: 'fixed',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          zIndex: 10000,
          background: 'rgba(0, 0, 0, 0.95)',
          border: '2px solid #00FFD1',
          padding: '32px 48px',
          fontFamily: 'monospace',
          fontSize: '18px',
          color: '#00FFD1',
          boxShadow: '0 0 40px rgba(0, 255, 209, 0.4)',
          animation: 'easterEggPulse 0.5s ease-out',
          whiteSpace: 'pre-line'
        }}>
          {easterEggActive.message}
        </div>
      )}

      {/* Main content */}
      <div style={{ position: 'relative', zIndex: 1 }}>
        <Header />
        <Hero />
        <About />
        <Skills />
        <Projects />
        <Timeline />
        <Contact />
        <Footer />
      </div>

      <style>{`
        @keyframes easterEggPulse {
          0% {
            transform: translate(-50%, -50%) scale(0.8);
            opacity: 0;
          }
          100% {
            transform: translate(-50%, -50%) scale(1);
            opacity: 1;
          }
        }
      `}</style>
    </div>
  );
}

export default App;